import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import { AddOns } from '../../../constants/add-ons';
import { MESH_ADD_ONS } from '../../../pages/settings/add-on-marketplace/constants';
import { FormattedCurrency } from '../../formatted-currency';
import '../../../prop-types/add-on.types';
import { isAddOnAvailableForTrial } from '../../../pages/settings/add-on-marketplace/helpers';
import { messages } from './messages';
import styles from './payment-disclaimer.module.less';

/**
 * @param {object} props
 * @param {AddOnPropType} props.addOn
 * @returns {JSX.Element}
 */
export const PaymentDisclaimer = ({ addOn }) => {
  const MESH_PRICE_PER_USE = 0.03;
  const canTrial = isAddOnAvailableForTrial(addOn);
  const isMeshAddOn = MESH_ADD_ONS.includes(addOn.code);

  const nonMeshDisclaimer = canTrial ? messages.trialPaymentDisclaimer : messages.addOnPaymentDisclaimer;
  const meshDisclaimer =
    addOn.code === AddOns.DropShip ? messages.dropShipAdditionalCharges : messages.fulfillmentProviderBundleAdditionalCharges;

  const disclaimer = isMeshAddOn ? meshDisclaimer : nonMeshDisclaimer;

  const price = isMeshAddOn ? MESH_PRICE_PER_USE : addOn.price.value;
  const fraction = isMeshAddOn ? 2 : 0;

  return (
    <Text
      className={styles['payment-disclaimer']}
      textType={TextType.Caption}
      value={
        <FormattedMessage
          {...disclaimer}
          values={{
            price: <FormattedCurrency currencyCode={addOn.price.code} fractionDigits={fraction} value={price} />,
          }}
        />
      }
    />
  );
};
